<template>
    <div
        class="flippable-card"
        :class="{active}"
        :style="{width, height}"
    >
        <div class="card front">
            <img
                v-if="frontImage"
                class="card-background"
                :src="frontImage"
            >
            <div class="card-content" :style="contentStyle">
                <slot name="front" />
            </div>
        </div>
        <div class="card back">
            <img
                v-if="backImage"
                class="card-background"
                :src="backImage"
            >
            <div class="card-content" :style="contentStyle">
                <slot name="back" />
            </div>
        </div>
    </div>
</template>

<script>
import gsap from 'gsap';

export default {
    name: 'FlippableCard',
    props: {
        width: {
            type: String,
            default: null
        },
        height: {
            type: String,
            default: null
        },
        contentStyle: {
            type: Object,
            default: null
        },
        frontImage: {
            type: String,
            default: null
        },
        backImage: {
            type: String,
            default: null
        },
        flipDuration: {
            type: Number,
            default: 1
        },
        flipped: {
            type: Boolean,
            default: false
        },
        active: {
            type: Boolean,
            default: true
        },
        frontOnly: {
            type: Boolean,
            default: false
        },
        reverse: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        flipped(flipped)
        {
            this.$audioController.play('flip', {volume: 0.4});
            if (flipped)
            {
                this._timeline.play();
                return;
            }
            this._timeline.reverse();
        }
    },
    mounted()
    {
        this._prepareTimeline();
    },
    methods: {
        _prepareTimeline()
        {
            const {children} = this.$el;
            gsap.set(this.$el, {
                transformStyle: 'preserve-3d',
                transformPerspective: 1000,
                z: 0
            });
            gsap.set(children, {
                transformStyle: 'preserve-3d',
                rotationY: 0,
                rotationZ: 0,
                opacity: 1
            });
            gsap.set(children[1], {
                rotationY: 180,
                rotationZ: 180,
                opacity: 0
            });

            const halfDuration = this.flipDuration / 2;
            const sign = this.reverse ? '-' : '+';

            if (!this.frontOnly)
            {
                this._timeline = gsap.timeline({paused: true})
                    .to(
                        children,
                        {rotationX: `${sign}=180`, duration: this.flipDuration, ease: 'sine.inOut'}
                    )
                    .to(
                        this.$el,
                        {z: 50, duration: halfDuration, yoyo: true, repeat: 1},
                        0
                    )
                    .set(children[0], {opacity: 0}, halfDuration)
                    .set(children[1], {opacity: 1}, halfDuration);
            }
            else
            {
                this._timeline = gsap.timeline({paused: true})
                    .to(
                        children[0],
                        {rotationX: `${sign}=90`, duration: halfDuration, ease: 'sine.in'}
                    )
                    .to(
                        this.$el,
                        {z: 50, duration: halfDuration},
                        0
                    )
                    .set(children[0], {opacity: 0}, halfDuration);
            }

            if (this.flipped)
            {
                this._timeline.progress(1);
            }
        }
    }
};
</script>

<style lang="scss" src="./FlippableCard.scss" />

